<template>
  <div>
    <svg
      v-if="template == 'abriron1'"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      version="1.1"
      x="0px"
      y="0px"
      viewBox="0 0 595.276 841"
      style="enable-background:new 0 0 595.276 841;"
      xml:space="preserve"
    >
      <g id="OBJECTS">
        <g>
          <rect
            x="-8.504"
            y="-8.504"
            :style="{'fill' : color.color1}"
            width="612.283"
            height="56.098"
          />
          <rect
            x="-8.504"
            y="814.794"
            :style="{'fill' : color.color1}"
            width="612.283"
            height="27.599"
          />
          <g>
            <defs>
              <rect
                id="SVGID_1_"
                x="-8.504"
                y="-8.504"
                width="612.283"
                height="858.898"
              />
            </defs>
            <clipPath id="SVGID_00000127009208928399275620000013843848086645545092_">
              <use
                xlink:href="#SVGID_1_"
                style="overflow:visible;"
              />
            </clipPath>
            <g>
              <polygon
                :style="{'fill' : color.color3}"
                points="115.606,-23.391 -25.843,-23.391 -25.843,118.058     "
              />
              <g>
                <polygon
                  :style="{'fill' : color.color2}"
                  points="196.195,-84.482 134.516,-22.803 134.461,-22.858 134.461,-59.445 196.195,-121.179             "
                />
                <polygon
                  :style="{'fill' : color.color5}"
                  points="265.406,-86.299 168.213,10.894 168.158,10.839 168.158,-22.768 265.406,-120.015             "
                />
                <rect
                  x="134.461"
                  y="-22.858"
                  :style="{'fill' : color.color2}"
                  width="33.697"
                  height="33.697"
                />
                <polygon
                  :style="{'fill' : color.color1}"
                  points="168.158,47.548 201.855,47.548 279.047,-29.644 279.047,-60.711 276.526,-60.711             "
                />
                <polygon
                  :style="{'fill' : color.color2}"
                  points="298.227,-82.412 168.213,47.602 168.158,47.548 168.158,10.96 298.227,-119.108             "
                />
                <polygon
                  :style="{'fill' : color.color2}"
                  points="338.791,-55.582 201.909,81.299 201.855,81.244 201.855,47.638 338.791,-89.298             "
                />
                <rect
                  x="168.158"
                  y="47.548"
                  :style="{'fill' : color.color5}"
                  width="33.697"
                  height="33.697"
                />
              </g>
              <g>
                <polygon
                  :style="{'fill' : color.color3}"
                  points="714.766,-26.042 608.581,80.142 608.634,80.195 643.89,80.195 750.127,-26.042      "
                />
                <polygon
                  :style="{'fill' : color.color3}"
                  points="661.404,-37.621 576.062,47.72 576.163,47.724 608.547,47.724 693.892,-37.621      "
                />
                <rect
                  x="576.163"
                  y="47.724"
                  :style="{'fill' : color.color4}"
                  width="32.471"
                  height="32.471"
                />
                <polygon
                  :style="{'fill' : color.color3}"
                  points="668.97,-80.56 540.738,47.672 540.79,47.724 576.047,47.724 704.331,-80.56      "
                />
                <polygon
                  :style="{'fill' : color.color3}"
                  points="670.107,-146.638 508.267,15.201 508.32,15.253 540.704,15.253 702.596,-146.638             "
                />
                <rect
                  x="508.32"
                  y="15.253"
                  :style="{'fill' : color.color4}"
                  width="32.471"
                  height="32.471"
                />
                <polygon
                  :style="{'fill' : color.color3}"
                  points="634.732,-146.636 472.895,15.201 472.947,15.253 508.203,15.253 670.093,-146.636             "
                />
                <polygon
                  :style="{'fill' : color.color3}"
                  points="576.022,-152.867 440.424,-17.27 440.477,-17.217 472.86,-17.217 608.511,-152.867             "
                />
                <rect
                  x="440.477"
                  y="-17.217"
                  :style="{'fill' : color.color4}"
                  width="32.471"
                  height="32.471"
                />
              </g>
              <polygon
                :style="{'fill' : color.color2}"
                points="488.047,863.275 629.585,863.275 629.585,721.736     "
              />
              <g>
                <polygon
                  :style="{'fill' : color.color3}"
                  points="-62.895,812.941 0.159,749.887 0.107,749.834 -35.149,749.834 -98.256,812.941      "
                />
                <polygon
                  :style="{'fill' : color.color3}"
                  points="-52.687,867.65 32.654,782.309 32.553,782.305 0.107,782.305 -85.176,867.65      "
                />
                <rect
                  x="0.107"
                  y="749.834"
                  :style="{'fill' : color.color4}"
                  width="32.471"
                  height="32.471"
                />
                <polygon
                  :style="{'fill' : color.color3}"
                  points="-60.229,910.589 68.003,782.358 67.95,782.305 32.694,782.305 -95.59,910.589      "
                />
                <polygon
                  :style="{'fill' : color.color3}"
                  points="-61.366,976.668 100.473,814.828 100.421,814.776 67.95,814.776 -93.855,976.668             "
                />
                <rect
                  x="67.95"
                  y="782.305"
                  :style="{'fill' : color.color4}"
                  width="32.471"
                  height="32.471"
                />
                <path
                  :style="{'fill' : color.color1}"
                  d="M135.793,814.776v32.471c0,0-56.779,59.312-59.312,59.312c-2.533,0-32.366,0-32.366,0       L135.793,814.776z"
                />
                <polygon
                  :style="{'fill' : color.color1}"
                  points="68.024,782.261 67.95,814.776 -12.988,895.744 -23.654,874.044      "
                />
                <polygon
                  :style="{'fill' : color.color1}"
                  points="0.192,749.839 0.117,782.382 -80.892,863.421 -91.567,841.702      "
                />
                <polygon
                  :style="{'fill' : color.color3}"
                  points="-25.992,976.666 135.846,814.828 135.793,814.776 100.537,814.776 -61.353,976.666             "
                />
                <polygon
                  :style="{'fill' : color.color3}"
                  points="-9.173,1024.788 168.316,847.299 168.264,847.246 135.793,847.246 -41.662,1024.788             "
                />
                <rect
                  x="135.793"
                  y="814.776"
                  :style="{'fill' : color.color4}"
                  width="32.471"
                  height="32.471"
                />
              </g>
            </g>
          </g>
          <g>
            <polygon
              :style="{'fill' : color.color3}"
              points="432.548,832.862 445.315,832.862 445.315,820.094    "
            />
            <polygon
              :style="{'fill' : color.color2}"
              points="407.013,832.862 419.78,832.862 419.78,820.094    "
            />
            <polygon
              :style="{'fill' : color.color3}"
              points="381.478,832.862 394.245,832.862 394.245,820.094    "
            />
            <polygon
              :style="{'fill' : color.color2}"
              points="355.943,832.862 368.71,832.862 368.71,820.094    "
            />
            <polygon
              :style="{'fill' : color.color3}"
              points="330.408,832.862 343.175,832.862 343.175,820.094    "
            />
            <polygon
              :style="{'fill' : color.color2}"
              points="304.873,832.862 317.64,832.862 317.64,820.094    "
            />
          </g>
        </g>
      </g>
    </svg>
    <svg
      v-if="template == 'abriron2'"
      x="0px"
      y="0px"
      viewBox="0 0 595.276 841"
      style="enable-background:new 0 0 595.276 841;"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient
          id="gradient-0"
          gradientUnits="userSpaceOnUse"
          x1="295.697"
          y1="-8.504"
          x2="295.697"
          y2="88.442"
        >
          <stop
            offset="0"
            :style="{'stop-color' : color.color1}"
          />
          <stop
            offset="1"
            :style="{'stop-color' : color.color4}"
          />
        </linearGradient>
      </defs>
      <g id="OBJECTS">
        <g>
          <g>
            <defs>
              <rect
                id="SVGID_1_"
                x="-8.504"
                y="-8.504"
                width="612.283"
                height="858.898"
              />
            </defs>
            <clipPath id="SVGID_00000120549937014479107850000005555152656919434902_">
              <rect
                x="-8.504"
                y="-8.504"
                width="612.283"
                height="858.898"
                style="overflow: visible;"
              />
            </clipPath>
            <g
              style="clip-path:url(#SVGID_00000120549937014479107850000005555152656919434902_);"
              transform="matrix(1, 0, 0, 1, 1.294214, -0.647113)"
            >
              <g transform="matrix(1, 0, 0, 1, -102.19977, 35.415638)">
                <radialGradient
                  id="SVGID_00000125586229906657515770000013445674848138280376_"
                  cx="110.7759"
                  cy="584.2944"
                  r="477.6465"
                  gradientTransform="matrix(-1 0 0 0.8748 583.1153 106.6981)"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop
                    offset="0.2055"
                    :style="{'stop-color' : color.color1}"
                  />
                  <stop
                    offset="0.2477"
                    :style="{'stop-color' : color.color1}"
                  />
                  <stop
                    offset="0.4863"
                    :style="{'stop-color' : color.color1}"
                  />
                  <stop
                    offset="0.6997"
                    :style="{'stop-color' : color.color1}"
                  />
                  <stop
                    offset="0.8782"
                    :style="{'stop-color' : color.color1}"
                  />
                  <stop
                    offset="1"
                    :style="{'stop-color' : color.color1}"
                  />
                </radialGradient>
                <path
                  style="fill:url(#SVGID_00000125586229906657515770000013445674848138280376_);"
                  d="M603.846,821.456v57.89H-8.437v-46.681c0,0,127.267-57.399,324.977-57.399S603.846,821.456,603.846,821.456z"
                />
                <g>
                  <radialGradient
                    id="SVGID_00000049911933155800977390000012159653364123951781_"
                    cx="-655.6994"
                    cy="1203.6003"
                    r="122.4368"
                    gradientTransform="matrix(-1.9765 0.0823 0.0593 0.9985 -867.4375 -440.1475)"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop
                      offset="0"
                      :style="{'stop-color' : color.color3}"
                    />
                    <stop
                      offset="1"
                      :style="{'stop-color' : color.color4}"
                    />
                  </radialGradient>
                  <path
                    style="fill:url(#SVGID_00000049911933155800977390000012159653364123951781_);"
                    d="M-64.203,858.531c210.737-119.763,540.087-125.647,730.096-38.447c-9.792,6.6-19.584,13.2-29.376,19.801C478.83,753.57,160.821,743.224-64.203,858.531z"
                  />
                  <radialGradient
                    id="SVGID_00000157298188153445577530000017681371714901268385_"
                    cx="-656.5322"
                    cy="1221.6813"
                    r="358.072"
                    gradientTransform="matrix(-1.9725 0.1502 0.0593 0.9985 -865.2245 -398.4704)"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop
                      offset="0"
                      :style="{'stop-color' : color.color3}"
                    />
                    <stop
                      offset="1"
                      :style="{'stop-color' : color.color4}"
                    />
                  </radialGradient>
                  <path
                    style="fill:url(#SVGID_00000157298188153445577530000017681371714901268385_);"
                    d="M-27.709,841.452c214.559-102.329,519.502-92.763,679.653-3.158c-10.146,5.719-21.793,23.007-30.439,17.159C492.182,767.976,216.806,742.184-27.709,841.452z"
                  />
                </g>
              </g>
              <g
                transform="matrix(1.011522, 0, 0, 0.953324, 2.791428, -24.903664)"
                style=""
              >
                <path
                  :style="{'fill' : color.color1}"
                  d="M 601.838 88.442 L 601.838 -8.504 L -10.445 -8.504 L -10.445 77.132 C -10.445 77.132 94.83 25.653 281.042 25.653 C 467.254 25.653 601.838 88.442 601.838 88.442 Z"
                />
                <g>
                  <radialGradient
                    id="SVGID_00000142174250476451159050000001351435881678517665_"
                    cx="-677.9474"
                    cy="462.0608"
                    r="122.4368"
                    gradientTransform="matrix(1.9765 0.0823 -0.0593 0.9985 1469.1263 -440.1475)"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop
                      offset="0"
                      :style="{'stop-color' : color.color3}"
                    />
                    <stop
                      offset="1"
                      :style="{'stop-color' : color.color4}"
                    />
                  </radialGradient>
                  <path
                    style="fill:url(#SVGID_00000142174250476451159050000001351435881678517665_);"
                    d="M665.892,116.272C455.155-3.491,125.805-9.374-64.203,77.825c9.792,6.6,19.584,13.2,29.376,19.801C122.859,11.312,440.868,0.966,665.892,116.272z"
                  />
                  <radialGradient
                    id="SVGID_00000111889079126656740020000001576158042398750638_"
                    cx="-678.7798"
                    cy="481.6546"
                    r="358.072"
                    gradientTransform="matrix(1.9725 0.1502 -0.0593 0.9985 1466.9135 -398.4704)"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop
                      offset="0"
                      :style="{'stop-color' : color.color3}"
                    />
                    <stop
                      offset="1"
                      :style="{'stop-color' : color.color4}"
                    />
                  </radialGradient>
                  <path
                    :style="{'stop-color' : color.color4}"
                    style="fill:url(#SVGID_00000111889079126656740020000001576158042398750638_);"
                    d="M629.398,99.194C414.839-3.135,109.896,6.431-50.254,96.036c10.146,5.719,21.793,23.007,30.439,17.159C109.507,25.718,384.882-0.074,629.398,99.194z"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
    <svg
      v-if="template == 'abriron3'"
      x="0px"
      y="0px"
      viewBox="0 0 595.276 841"
      style="enable-background:new 0 0 595.276 841;"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="_x30_1">
        <g>
          <g>
            <g />
          </g>
          <linearGradient
            id="SVGID_00000001651889313981441730000017998860869709100448_"
            gradientUnits="userSpaceOnUse"
            x1="-89.154"
            y1="613.4453"
            x2="524.0073"
            y2="961.8323"
            gradientTransform="matrix(1, 0, 0, 1, -37.951073, -0.000001)"
          >
            <stop
              offset="0"
              :style="{'fill' : color.color2}"
            />
            <stop
              offset="1"
              :style="{'fill' : color.color4}"
            />
          </linearGradient>
          <path
            :style="{'fill' : color.color2}"
            d="M 12.741 808.538 L -4.73 791.067 C -9.354 786.444 -11.951 780.173 -11.951 773.635 L -11.951 532.919 C -11.951 513.589 -27.621 497.919 -46.951 497.919 L -46.951 815.759 L -46.951 850.759 L -11.951 850.759 L 606.889 850.759 L 607.5 815.758 L 30.173 815.759 C 23.635 815.759 17.364 813.162 12.741 808.538 Z"
          />
          <path
            :style="{'fill' : color.color3}"
            d="M 583.311 33.141 L 600.782 50.612 C 605.405 55.235 608.003 61.506 608.003 68.045 L 608.003 308.76 C 608.003 328.09 623.673 343.76 643.003 343.76 L 643.003 25.92 L 643.003 -9.08 L 608.003 -9.08 L -11.448 -8.468 L -10.836 24.695 L 565.879 25.92 C 572.417 25.92 578.688 28.517 583.311 33.141 Z"
          />
        </g>
      </g>
      <g id="_x30_2" />
      <g id="_x30_3" />
    </svg>
    <svg
      v-if="template == 'abriron4'"
      viewBox="0 0 595.276 841"
      style="enable-background:new 0 0 595.276 841;"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, -1.4210854715202004e-14)">
        <g
          style="opacity: 0.85;"
          transform="matrix(0.997787, 0, 0, 1.002874, 1.517854, 0.288508)"
        >
          <defs>
            <rect
              id="SVGID_1_"
              x="0.082"
              style="opacity:0.85;"
              width="595.276"
              height="841.89"
            />
          </defs>
          <clipPath id="SVGID_00000101080387134142294680000014569703884904866475_">
            <rect
              x="0.082"
              style="opacity: 0.85; overflow: visible;"
              width="595.276"
              height="841.89"
            />
          </clipPath>
          <g style="clip-path:url(#SVGID_00000101080387134142294680000014569703884904866475_);">
            <polygon
              style="fill:#FFFFFF;"
              points="200.819,216.966 226.218,242.596 200.819,268.239 175.399,242.596"
            />
            <polygon
              style="fill:#FDFEFF;"
              points="297.579,168.154 322.978,193.786 297.579,219.391 272.182,193.786"
            />
            <polygon
              style="fill:#F3F3F3;"
              points="200.819,21.697 226.218,47.327 200.819,72.958 175.399,47.327"
            />
            <polygon
              style="fill:#F3F3F3;"
              points="225.017,46.116 250.391,71.746 225.017,97.351 199.62,71.746"
            />
            <polygon
              style="fill:#F9F9FA;"
              points="249.188,70.509 274.608,96.164 249.188,121.795 223.791,96.164"
            />
            <polygon
              style="fill:#F6F6F6;"
              points="273.406,94.925 298.78,120.556 273.406,146.188 247.986,120.556"
            />
            <polygon
              style="fill:#F6F6F6;"
              points="297.579,119.369 322.978,144.974 297.579,170.581 272.182,144.974"
            />
            <polygon
              style="fill:#FDFEFF;"
              points="321.775,143.764 347.17,169.368 321.775,194.998 296.378,169.368"
            />
            <polygon
              style="fill:#FDFEFF;"
              points="345.971,168.154 371.341,193.786 345.971,219.391 320.549,193.786"
            />
            <polygon
              style="fill:#FDFEFF;"
              points="370.117,192.572 395.514,218.203 370.117,243.835 344.743,218.203"
            />
            <polygon
              style="fill:#FDFEFF;"
              points="394.312,216.966 419.732,242.596 394.312,268.239 368.915,242.596"
            />
            <polygon
              style="fill:#FFFFFF;"
              points="418.507,241.386 443.93,267.002 418.507,292.632 393.111,267.002"
            />
            <polygon
              style="fill:#F2F2F2;"
              points="200.819,-27.138 226.218,-1.508 200.819,24.148 175.399,-1.508"
            />
            <polygon
              style="fill:#F3F3F3;"
              points="225.017,-2.721 250.391,22.909 225.017,48.541 199.62,22.909"
            />
            <polygon
              style="fill:#F3F3F3;"
              points="249.188,21.697 274.608,47.327 249.188,72.958 223.791,47.327"
            />
            <polygon
              style="fill:#F3F3F3;"
              points="273.406,46.116 298.78,71.746 273.406,97.351 247.986,71.746"
            />
            <polygon
              style="fill:#F3F3F3;"
              points="297.579,70.509 322.978,96.164 297.579,121.795 272.182,96.164"
            />
            <polygon
              style="fill:#F3F3F3;"
              points="321.775,94.925 347.17,120.556 321.775,146.188 296.378,120.556"
            />
            <polygon
              style="fill:#F9F9FA;"
              points="345.971,119.369 371.341,144.974 345.971,170.581 320.549,144.974"
            />
            <polygon
              style="fill:#FDFEFF;"
              points="370.117,143.764 395.514,169.368 370.117,194.998 344.743,169.368"
            />
            <polygon
              style="fill:#FDFEFF;"
              points="394.312,168.154 419.732,193.786 394.312,219.391 368.915,193.786"
            />
            <polygon
              style="fill:#F9F9FA;"
              points="418.507,192.572 443.93,218.203 418.507,243.835 393.111,218.203"
            />
            <polygon
              style="fill:#FDFEFF;"
              points="442.704,216.966 468.101,242.596 442.704,268.239 417.307,242.596"
            />
            <polygon
              style="fill:#E7E7E7;"
              points="200.819,-75.95 226.218,-50.319 200.819,-24.691 175.399,-50.319"
            />
            <polygon
              style="fill:#E7E7E7;"
              points="225.017,-51.556 250.391,-25.926 225.017,-0.298 199.62,-25.926"
            />
            <polygon
              style="fill:#E7E7E7;"
              points="249.188,-27.138 274.608,-1.508 249.188,24.148 223.791,-1.508"
            />
            <polygon
              style="fill:#F2F2F2;"
              points="273.406,-2.721 298.78,22.909 273.406,48.541 247.986,22.909"
            />
            <polygon
              style="fill:#E4E4E4;"
              points="297.579,21.697 322.978,47.327 297.579,72.958 272.182,47.327"
            />
            <polygon
              style="fill:#F1F0F0;"
              points="321.775,46.116 347.17,71.746 321.775,97.351 296.378,71.746"
            />
            <polygon
              style="fill:#F5F6F6;"
              points="345.971,70.509 371.341,96.164 345.971,121.795 320.549,96.164"
            />
            <polygon
              style="fill:#F3F3F3;"
              points="370.117,94.925 395.514,120.556 370.117,146.188 344.743,120.556"
            />
            <polygon
              style="fill:#F7F8F8;"
              points="394.312,119.369 419.732,144.974 394.312,170.581 368.915,144.974"
            />
            <polygon
              style="fill:#FAFAFA;"
              points="418.507,143.764 443.93,169.368 418.507,194.998 393.111,169.368"
            />
            <polygon
              style="fill:#F7F8F8;"
              points="442.704,168.154 468.101,193.786 442.704,219.391 417.307,193.786"
            />
            <polygon
              style="fill:#F7F8F8;"
              points="466.9,192.572 492.272,218.203 466.9,243.835 441.501,218.203"
            />
            <polygon
              style="fill:#FFFFFF;"
              points="491.069,216.966 516.491,242.596 491.069,268.239 465.672,242.596"
            />
            <polygon
              style="fill:#FFFFFF;"
              points="515.265,241.386 540.662,267.002 515.265,292.632 489.868,267.002"
            />
            <polygon
              style="fill:#C2C1C1;"
              points="225.017,-100.368 250.391,-74.736 225.017,-49.106 199.62,-74.736"
            />
            <polygon
              style="fill:#DFDFDE;"
              points="249.188,-75.95 274.608,-50.319 249.188,-24.691 223.791,-50.319"
            />
            <polygon
              style="fill:#DDDDDC;"
              points="273.406,-51.556 298.78,-25.926 273.406,-0.298 247.986,-25.926"
            />
            <polygon
              style="fill:#EAEAEA;"
              points="297.579,-27.138 322.978,-1.508 297.579,24.148 272.182,-1.508"
            />
            <polygon
              style="fill:#E4E4E4;"
              points="321.775,-2.721 347.17,22.909 321.775,48.541 296.378,22.909"
            />
            <polygon
              style="fill:#E0E0DF;"
              points="345.971,21.697 371.341,47.327 345.971,72.958 320.549,47.327"
            />
            <polygon
              style="fill:#E7E7E7;"
              points="370.117,46.116 395.514,71.746 370.117,97.351 344.743,71.746"
            />
            <polygon
              style="fill:#F3F3F3;"
              points="394.312,70.509 419.732,96.164 394.312,121.795 368.915,96.164"
            />
            <polygon
              style="fill:#EFEEEE;"
              points="418.507,94.925 443.93,120.556 418.507,146.188 393.111,120.556"
            />
            <polygon
              style="fill:#F7F8F8;"
              points="442.704,119.369 468.101,144.974 442.704,170.581 417.307,144.974"
            />
            <polygon
              style="fill:#F7F8F8;"
              points="466.9,143.764 492.272,169.368 466.9,194.998 441.501,169.368"
            />
            <polygon
              style="fill:#FDFEFF;"
              points="491.069,168.154 516.491,193.786 491.069,219.391 465.672,193.786"
            />
            <polygon
              style="fill:#FDFEFF;"
              points="515.265,192.572 540.662,218.203 515.265,243.835 489.868,218.203"
            />
            <polygon
              style="fill:#FFFFFF;"
              points="539.461,216.966 564.858,242.596 539.461,268.239 514.065,242.596"
            />
            <polygon
              style="fill:#DFDFDE;"
              points="273.406,-100.368 298.78,-74.736 273.406,-49.106 247.986,-74.736"
            />
            <polygon
              style="fill:#DFDFDE;"
              points="297.579,-75.95 322.978,-50.319 297.579,-24.691 272.182,-50.319"
            />
            <polygon
              style="fill:#DFDFDE;"
              points="321.775,-51.556 347.17,-25.926 321.775,-0.298 296.378,-25.926"
            />
            <polygon
              style="fill:#E7E7E7;"
              points="345.971,-27.138 371.341,-1.508 345.971,24.148 320.549,-1.508"
            />
            <polygon
              style="fill:#EDEDED;"
              points="370.117,-2.721 395.514,22.909 370.117,48.541 344.743,22.909"
            />
            <polygon
              style="fill:#EDEDED;"
              points="394.312,21.697 419.732,47.327 394.312,72.958 368.915,47.327"
            />
            <polygon
              style="fill:#ECECEC;"
              points="418.507,46.116 443.93,71.746 418.507,97.351 393.111,71.746"
            />
            <polygon
              style="fill:#F6F6F6;"
              points="442.704,70.509 468.101,96.164 442.704,121.795 417.307,96.164"
            />
            <polygon
              style="fill:#F6F6F6;"
              points="466.9,94.925 492.272,120.556 466.9,146.188 441.501,120.556"
            />
            <polygon
              style="fill:#F3F3F3;"
              points="491.069,119.369 516.491,144.974 491.069,170.581 465.672,144.974"
            />
            <polygon
              style="fill:#EDEDED;"
              points="515.265,143.764 540.662,169.368 515.265,194.998 489.868,169.368"
            />
            <polygon
              style="fill:#F6F6F6;"
              points="539.461,168.154 564.858,193.786 539.461,219.391 514.065,193.786"
            />
            <polygon
              style="fill:#F6F6F6;"
              points="563.656,192.572 589.055,218.203 563.656,243.835 538.259,218.203"
            />
            <polygon
              style="fill:#FFFFFF;"
              points="587.827,216.966 613.249,242.596 587.827,268.239 562.43,242.596"
            />
            <polygon
              style="fill:#BBBBBB;"
              points="321.775,-100.368 347.17,-74.736 321.775,-49.106 296.378,-74.736"
            />
            <polygon
              style="fill:#E0E1E0;"
              points="345.971,-75.95 371.341,-50.319 345.971,-24.691 320.549,-50.319"
            />
            <polygon
              style="fill:#DFDFDE;"
              points="370.117,-51.556 395.514,-25.926 370.117,-0.298 344.743,-25.926"
            />
            <polygon
              style="fill:#DFDFDE;"
              points="394.312,-27.138 419.732,-1.508 394.312,24.148 368.915,-1.508"
            />
            <polygon
              style="fill:#EDEDED;"
              points="418.507,-2.721 443.93,22.909 418.507,48.541 393.111,22.909"
            />
            <polygon
              style="fill:#ECECEC;"
              points="442.704,21.697 468.101,47.327 442.704,72.958 417.307,47.327"
            />
            <polygon
              style="fill:#F1F0F0;"
              points="466.9,46.116 492.272,71.746 466.9,97.351 441.501,71.746"
            />
            <polygon
              style="fill:#F5F6F6;"
              points="491.069,70.509 516.491,96.164 491.069,121.795 465.672,96.164"
            />
            <polygon
              style="fill:#ECECEC;"
              points="515.265,94.925 540.662,120.556 515.265,146.188 489.868,120.556"
            />
            <polygon
              style="fill:#EDEDED;"
              points="539.461,119.369 564.858,144.974 539.461,170.581 514.065,144.974"
            />
            <polygon
              style="fill:#ECECEC;"
              points="563.656,143.764 589.055,169.368 563.656,194.998 538.259,169.368"
            />
            <polygon
              style="fill:#F9F9FA;"
              points="587.827,168.154 613.249,193.786 587.827,219.391 562.43,193.786"
            />
            <polygon
              style="fill:#FBFCFC;"
              points="612.048,192.572 637.42,218.203 612.048,243.835 586.628,218.203"
            />
            <polygon
              style="fill:#D7D6D6;"
              points="370.117,-100.368 395.514,-74.736 370.117,-49.106 344.743,-74.736"
            />
            <polygon
              style="fill:#DFDFDE;"
              points="394.312,-75.95 419.732,-50.319 394.312,-24.691 368.915,-50.319"
            />
            <polygon
              style="fill:#E3E3E3;"
              points="418.507,-51.556 443.93,-25.926 418.507,-0.298 393.111,-25.926"
            />
            <polygon
              style="fill:#E3E3E3;"
              points="442.704,-27.138 468.101,-1.508 442.704,24.148 417.307,-1.508"
            />
            <polygon
              style="fill:#ECECEC;"
              points="466.9,-2.721 492.272,22.909 466.9,48.541 441.501,22.909"
            />
            <polygon
              style="fill:#F0EFEF;"
              points="491.069,21.697 516.491,47.327 491.069,72.958 465.672,47.327"
            />
            <polygon
              style="fill:#EFEEEE;"
              points="515.265,46.116 540.662,71.746 515.265,97.351 489.868,71.746"
            />
            <polygon
              style="fill:#F3F3F3;"
              points="539.461,70.509 564.858,96.164 539.461,121.795 514.065,96.164"
            />
            <polygon
              style="fill:#F3F3F3;"
              points="563.656,94.925 589.055,120.556 563.656,146.188 538.259,120.556"
            />
            <polygon
              style="fill:#EDEDED;"
              points="587.827,119.369 613.249,144.974 587.827,170.581 562.43,144.974"
            />
            <polygon
              style="fill:#F0EFEF;"
              points="612.048,143.764 637.42,169.368 612.048,194.998 586.628,169.368"
            />
            <polygon
              style="fill:#FBFCFC;"
              points="636.219,168.154 661.591,193.786 636.219,219.391 610.845,193.786"
            />
            <polygon
              style="fill:#FFFFFF;"
              points="660.365,192.572 685.812,218.203 660.365,243.835 635.017,218.203"
            />
            <polygon
              style="fill:#E0E1E0;"
              points="418.507,-100.368 443.93,-74.736 418.507,-49.106 393.111,-74.736"
            />
            <polygon
              style="fill:#E2E2E2;"
              points="442.704,-75.95 468.101,-50.319 442.704,-24.691 417.307,-50.319"
            />
            <polygon
              style="fill:#E2E2E2;"
              points="466.9,-51.556 492.272,-25.926 466.9,-0.298 441.501,-25.926"
            />
            <polygon
              style="fill:#ECECEC;"
              points="491.069,-27.138 516.491,-1.508 491.069,24.148 465.672,-1.508"
            />
            <polygon
              style="fill:#F3F3F3;"
              points="515.265,-2.721 540.662,22.909 515.265,48.541 489.868,22.909"
            />
            <polygon
              style="fill:#EDEDED;"
              points="539.461,21.697 564.858,47.327 539.461,72.958 514.065,47.327"
            />
            <polygon
              style="fill:#EBEBEB;"
              points="563.656,46.116 589.055,71.746 563.656,97.351 538.259,71.746"
            />
            <polygon
              style="fill:#ECECEC;"
              points="587.827,70.509 613.249,96.164 587.827,121.795 562.43,96.164"
            />
            <polygon
              style="fill:#EFEEEE;"
              points="612.048,94.925 637.42,120.556 612.048,146.188 586.628,120.556"
            />
            <polygon
              style="fill:#F3F3F3;"
              points="636.219,119.369 661.591,144.974 636.219,170.581 610.845,144.974"
            />
            <polygon
              style="fill:#F7F8F8;"
              points="660.365,143.764 685.812,169.368 660.365,194.998 635.017,169.368"
            />
            <polygon
              style="fill:#DDDDDC;"
              points="466.9,-100.368 492.272,-74.736 466.9,-49.106 441.501,-74.736"
            />
            <polygon
              style="fill:#D3D3D3;"
              points="491.069,-75.95 516.491,-50.319 491.069,-24.691 465.672,-50.319"
            />
            <polygon
              style="fill:#D2D3D3;"
              points="515.265,-51.556 540.662,-25.926 515.265,-0.298 489.868,-25.926"
            />
            <polygon
              style="fill:#D8D9D8;"
              points="539.461,-27.138 564.858,-1.508 539.461,24.148 514.065,-1.508"
            />
            <polygon
              style="fill:#EDEDED;"
              points="563.656,-2.721 589.055,22.909 563.656,48.541 538.259,22.909"
            />
            <polygon
              style="fill:#F0EFEF;"
              points="587.827,21.697 613.249,47.327 587.827,72.958 562.43,47.327"
            />
            <polygon
              style="fill:#D0D1D1;"
              points="612.048,46.116 637.42,71.746 612.048,97.351 586.628,71.746"
            />
            <polygon
              style="fill:#EFEEEE;"
              points="636.219,70.509 661.591,96.164 636.219,121.795 610.845,96.164"
            />
            <polygon
              style="fill:#F1F0F0;"
              points="660.365,94.925 685.812,120.556 660.365,146.188 635.017,120.556"
            />
            <polygon
              style="fill:#DCDBDB;"
              points="515.265,-100.368 540.662,-74.736 515.265,-49.106 489.868,-74.736"
            />
            <polygon
              style="fill:#DDDDDC;"
              points="539.461,-75.95 564.858,-50.319 539.461,-24.691 514.065,-50.319"
            />
            <polygon
              style="fill:#DDDDDC;"
              points="563.656,-51.556 589.055,-25.926 563.656,-0.298 538.259,-25.926"
            />
            <polygon
              style="fill:#EAEAEA;"
              points="587.827,-27.138 613.249,-1.508 587.827,24.148 562.43,-1.508"
            />
            <polygon
              style="fill:#F2F2F2;"
              points="612.048,-2.721 637.42,22.909 612.048,48.541 586.628,22.909"
            />
            <polygon
              style="fill:#F2F2F2;"
              points="636.219,21.697 661.591,47.327 636.219,72.958 610.845,47.327"
            />
            <polygon
              style="fill:#E2E2E2;"
              points="660.365,46.116 685.812,71.746 660.365,97.351 635.017,71.746"
            />
            <polygon
              style="fill:#DDDDDC;"
              points="563.656,-100.368 589.055,-74.736 563.656,-49.106 538.259,-74.736"
            />
            <polygon
              style="fill:#E2E2E2;"
              points="587.827,-75.95 613.249,-50.319 587.827,-24.691 562.43,-50.319"
            />
            <polygon
              style="fill:#E2E2E2;"
              points="612.048,-51.556 637.42,-25.926 612.048,-0.298 586.628,-25.926"
            />
            <polygon
              style="fill:#EDEDED;"
              points="636.219,-27.138 661.591,-1.508 636.219,24.148 610.845,-1.508"
            />
            <polygon
              style="fill:#D9D9D8;"
              points="660.365,-2.721 685.812,22.909 660.365,48.541 635.017,22.909"
            />
            <polygon
              style="fill:#E0E1E0;"
              points="612.048,-100.368 637.42,-74.736 612.048,-49.106 586.628,-74.736"
            />
            <polygon
              style="fill:#E2E2E2;"
              points="636.219,-75.95 661.591,-50.319 636.219,-24.691 610.845,-50.319"
            />
            <polygon
              style="fill:#F2F2F2;"
              points="660.365,-51.556 685.812,-25.926 660.365,-0.298 635.017,-25.926"
            />
            <polygon
              style="fill:#F9F9FA;"
              points="660.365,-100.368 685.812,-74.736 660.365,-49.106 635.017,-74.736"
            />
          </g>
        </g>
        <rect
          x="0.041"
          transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 595.3578 21)"
          :style="{'fill' : color.color3}"
          width="595.276"
          height="21"
        />
        <g id="John_Smeeth_2_" />
        <rect
          x="0.164"
          y="805.5"
          :style="{'fill' : color.color2}"
          width="595.276"
          height="36.285"
        />
        <polygon
          :style="{'fill' : color.color3}"
          points="163.507,841.68 0.041,841.68 0.041,786.667 138.894,786.667"
        />
      </g>
    </svg>
    <svg
      v-if="template == 'abriron6'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 595.276 841"
      style="enable-background:new 0 0 595.276 841;"
    >
      <g transform="matrix(1, 0, 0, 1, 0, 2.842170943040401e-14)">
        <polygon
          :style="{fill:(color ? color.color1 : 'rgb(13, 13, 13)')}"
          points="6.339 45.315 61.024 45.315 119.363 -9 6.339 -9 -9 -9 -9 45.315"
        />
        <polygon
          :style="{fill:(color ? color.color4 : 'rgb(206, 24, 30)')}"
          style="fill: rgb(206, 24, 30);"
          points="93.375 -9 -9 -9 -9 86.312"
        />
        <polygon
          :style="{fill:(color ? color.color3 : 'rgb(237, 28, 36)')}"
          points="56.593 -9 -9 -9 -9 52.067"
        />
        <polygon
          :style="{fill:(color ? color.color1 : 'rgb(13, 13, 13)')}"
          points="591.996 806.617 547.633 806.617 523.969 828.649 500.305 850.68 591.996 850.68 604.44 850.68 604.44 828.649 604.44 806.617"
        />
        <polygon
          :style="{fill:(color ? color.color4 : 'rgb(206, 24, 30)')}"
          points="527.769 850.68 604.44 850.68 604.44 779.299"
        />
        <polygon
          :style="{fill:(color ? color.color3 : 'rgb(237, 28, 36)')}"
          points="561.905 850.68 604.44 850.68 604.44 811.08"
        />
      </g>
    </svg>
    <svg
      v-if="template == 'abriron5'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 595.276 841"
      style="enable-background:new 0 0 595.276 841;"
    >
      <g
        id="OBJECTS"
        transform="matrix(1, 0, 0, 1, 5.684341886080802e-14, 0)"
      >
        <defs>
          <rect
            id="SVGID_1_"
            x="-8.504"
            y="-8.504"
            width="612.283"
            height="858.898"
          />
        </defs>
        <clipPath id="SVGID_00000163041347574025050960000014014199663754001795_">
          <rect
            x="-8.504"
            y="-8.504"
            width="612.283"
            height="858.898"
            style="overflow: visible;"
          />
        </clipPath>
        <g
          style="clip-path: url('#SVGID_00000163041347574025050960000014014199663754001795_');"
          transform="matrix(1.011876, 0, 0, 1, 0.100995, -28.712437)"
        >
          <g transform="matrix(1, 0, 0, 1, -476.305763, 72.371606)">
            <rect
              x="396.351"
              y="-68.2"
              transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 859.2211 -69.8817)"
              :style="{'fill' : color.color2}"
              width="66.519"
              height="66.519"
            />
            <rect
              x="462.87"
              y="-68.2"
              transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 992.2593 -69.8817)"
              :style="{'fill' : color.color1}"
              width="66.519"
              height="66.519"
            />
            <rect
              x="529.389"
              y="-68.2"
              transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 1125.2975 -69.8817)"
              :style="{'fill' : color.color5}"
              width="66.519"
              height="66.519"
            />
            <g>
              <g>
                <g>
                  <g>
                    <polygon
                      :style="{'fill' : color.color5}"
                      points="421.856,-68.201 396.36,-68.201 396.36,-58.23 411.885,-58.23 411.885,-37.718 &#10;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;432.397,-37.718 432.397,-17.207 452.907,-17.207 452.907,-1.682 462.878,-1.682 462.878,-27.178 442.368,-27.178 &#10;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;442.368,-47.689 421.856,-47.689 &#9;&#9;&#9;&#9;&#9;&#9;&#9;"
                    />
                  </g>
                </g>
                <g>
                  <g>
                    <g>
                      <polygon
                        :style="{'fill' : color.color5}"
                        points="396.36,-22.164 396.36,-32.133 416.912,-32.133 416.912,-11.625 437.42,-11.625 &#10;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;437.42,-1.681 406.939,-1.681 406.939,-22.164 &#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;"
                      />
                    </g>
                  </g>
                </g>
                <g>
                  <g>
                    <polygon
                      :style="{'fill' : color.color5}"
                      points="442.361,-68.199 432.392,-68.199 432.392,-58.197 452.903,-58.197 452.903,-37.686 &#10;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;462.879,-37.686 462.879,-47.658 462.872,-47.658 462.872,-68.17 442.361,-68.17 &#9;&#9;&#9;&#9;&#9;&#9;&#9;"
                    />
                  </g>
                </g>
              </g>
            </g>
            <polygon
              :style="{'fill' : color.color1}"
              points="529.406,-1.682 558.508,-1.682 595.926,-68.201 566.823,-68.201 &#9;&#9;&#9;"
            />
            <path
              :style="{'fill' : color.color3}"
              d="M529.388-35.68C529-17.643,514.259-3.141,496.13-3.141c-18.13,0-32.871-14.502-33.259-32.539&#10;&#9;&#9;&#9;&#9;H529.388z"
            />
            <path
              :style="{'fill' : color.color2}"
              d="M529.368-68.199c-0.388,18.025-15.12,32.519-33.238,32.519c-18.119,0-32.851-14.493-33.239-32.519&#10;&#9;&#9;&#9;&#9;H529.368z"
            />
          </g>
          <g
            style="transform-origin: 2.889px 25.1245px;"
            transform="matrix(-1, 0, 0, -1, 575.313485, 20.216357)"
          >
            <g>
              <path
                :style="{'stroke' : color.color1}"
                style="fill:none;stroke-miterlimit:10;"
                d="M39.505,25.125c0,20.19-16.426,36.616-36.616,36.616h-36.616&#10;&#9;&#9;&#9;&#9;&#9;v-73.233H2.889C23.079-11.492,39.505,4.935,39.505,25.125z"
              />
              <g>
                <path
                  :style="{'fill' : color.color3}"
                  d="M2.889,7.287h-17.838v35.675H2.889c9.851,0,17.837-7.986,17.837-17.837l0,0&#10;&#9;&#9;&#9;&#9;&#9;&#9;C20.727,15.273,12.741,7.287,2.889,7.287z"
                />
              </g>
            </g>
          </g>
        </g>
        <g
          style="clip-path:url(#SVGID_00000163041347574025050960000014014199663754001795_);"
          transform="matrix(1, 0, 0, 1, 0, 28.712403)"
        >
          <rect
            x="-2.375"
            y="779.396"
            transform="matrix(6.123234e-17 -1 1 6.123234e-17 -781.7708 843.4622)"
            :style="{'fill' : color.color1}"
            width="66.441"
            height="66.442"
          />
          <rect
            x="462.692"
            y="779.34"
            transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 1308.4744 316.6482)"
            :style="{'fill' : color.color2}"
            width="66.441"
            height="66.442"
          />
          <rect
            x="529.134"
            y="779.34"
            transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 1374.9159 250.2066)"
            :style="{'fill' : color.color4}"
            width="66.441"
            height="66.442"
          />
          <rect
            x="196.95"
            y="779.396"
            transform="matrix(6.123234e-17 -1 1 6.123234e-17 -582.446 1042.7869)"
            :style="{'fill' : color.color5}"
            width="66.441"
            height="66.442"
          />
          <rect
            x="396.251"
            y="779.341"
            transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 1242.0328 383.0897)"
            :style="{'fill' : color.color4}"
            width="66.441"
            height="66.441"
          />
          <rect
            x="64.066"
            y="779.413"
            :style="{'fill' : color.color2}"
            width="66.442"
            height="66.442"
          />
          <rect
            x="130.508"
            y="779.413"
            :style="{'fill' : color.color4}"
            width="66.441"
            height="66.442"
          />
          <rect
            x="329.809"
            y="779.34"
            transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 1175.5912 449.5313)"
            :style="{'fill' : color.color5}"
            width="66.441"
            height="66.442"
          />
          <rect
            x="263.391"
            y="779.413"
            :style="{'fill' : color.color3}"
            width="66.442"
            height="66.442"
          />
          <g>
            <g>
              <g>
                <ellipse
                  transform="matrix(0.0291 -0.9996 0.9996 0.0291 -459.744 1151.8097)"
                  :style="{'fill' : color.color2}"
                  cx="363.03"
                  cy="812.561"
                  rx="33.221"
                  ry="33.221"
                />
              </g>
              <path
                :style="{'fill' : color.color5}"
                d="M345.844,812.561c0-9.476,7.71-17.186,17.186-17.186c9.476,0,17.186,7.71,17.186,17.186&#10;&#9;&#9;&#9;&#9;&#9;c0,9.477-7.71,17.186-17.186,17.186C353.554,829.747,345.844,822.038,345.844,812.561z"
              />
              <g>
                <path
                  :style="{'fill' : color.color1}"
                  d="M356.533,812.561c0-3.578,2.911-6.489,6.489-6.489c3.578,0,6.489,2.911,6.489,6.489&#10;&#9;&#9;&#9;&#9;&#9;&#9;c0,3.578-2.911,6.489-6.489,6.489C359.444,819.05,356.533,816.139,356.533,812.561z"
                />
              </g>
            </g>
          </g>
          <g>
            <g>
              <g>
                <polygon
                  :style="{'fill' : color.color4}"
                  points="38.6,779.413 64.066,779.413 64.066,789.372 48.559,789.372 48.559,809.859 &#10;&#9;&#9;&#9;&#9;&#9;&#9;28.072,809.859 28.072,830.346 7.585,830.346 7.585,845.854 -2.374,845.854 -2.374,820.387 18.112,820.387 18.112,799.9 &#10;&#9;&#9;&#9;&#9;&#9;&#9;38.6,799.9 &#9;&#9;&#9;&#9;&#9;"
                />
              </g>
            </g>
            <g>
              <g>
                <polygon
                  :style="{'fill' : color.color4}"
                  points="64.066,825.396 64.066,815.438 43.539,815.438 43.539,835.923 23.054,835.923 &#10;&#9;&#9;&#9;&#9;&#9;&#9;23.054,845.854 53.5,845.854 53.5,825.396 &#9;&#9;&#9;&#9;&#9;"
                />
              </g>
            </g>
            <g>
              <g>
                <polygon
                  :style="{'fill' : color.color4}"
                  points="18.119,779.372 28.077,779.372 28.077,789.376 7.589,789.376 7.589,809.892 &#10;&#9;&#9;&#9;&#9;&#9;&#9;-2.375,809.892 -2.375,799.917 -2.369,799.917 -2.369,779.401 18.119,779.401 &#9;&#9;&#9;&#9;&#9;"
                />
              </g>
            </g>
          </g>
          <g>
            <rect
              x="140.237"
              y="789.15"
              transform="matrix(0.7071 -0.7071 0.7071 0.7071 -526.6674 353.7858)"
              :style="{'fill' : color.color2}"
              width="46.975"
              height="46.975"
            />
            <rect
              x="149.614"
              y="798.528"
              transform="matrix(0.7071 0.7071 -0.7071 0.7071 622.5774 122.2468)"
              :style="{'fill' : color.color4}"
              width="28.22"
              height="28.22"
            />
            <rect
              x="158.022"
              y="806.936"
              transform="matrix(0.7071 0.7071 -0.7071 0.7071 622.5714 122.2428)"
              :style="{'fill' : color.color2}"
              width="11.405"
              height="11.405"
            />
          </g>
          <polygon
            :style="{'fill' : color.color4}"
            points="263.391,779.396 196.941,812.609 263.391,845.822 &#9;&#9;"
          />
          <g>
            <path
              :style="{'fill' : color.color1}"
              d="M115.834,812.583c0,9.885-8.042,17.927-17.927,17.927c-9.885,0-17.927-8.042-17.927-17.927&#10;&#9;&#9;&#9;&#9;c0-9.885,8.042-17.927,17.927-17.927C107.792,794.655,115.834,802.698,115.834,812.583z"
            />
          </g>
          <polygon
            :style="{'fill' : color.color5}"
            points="462.692,845.765 462.692,816.696 529.134,779.322 529.134,808.391 &#9;&#9;"
          />
          <g>
            <path
              :style="{'fill' : color.color2}"
              d="M429.476,812.539h3.552c16.385,0,29.669-13.284,29.669-29.67v-3.551h-3.551&#10;&#9;&#9;&#9;&#9;c-16.387,0-29.67,13.284-29.67,29.669V812.539z"
            />
            <path
              :style="{'fill' : color.color2}"
              d="M429.476,816.091c0,16.385,13.283,29.669,29.67,29.669h3.551v-3.551&#10;&#9;&#9;&#9;&#9;c0-16.386-13.283-29.67-29.669-29.67h-3.552V816.091z"
            />
            <path
              :style="{'fill' : color.color2}"
              d="M429.476,808.987c0-16.385-13.284-29.669-29.67-29.669h-3.551v3.551&#10;&#9;&#9;&#9;&#9;c0,16.386,13.284,29.67,29.669,29.67h3.552V808.987z"
            />
            <path
              :style="{'fill' : color.color2}"
              d="M429.476,812.539h-3.552c-16.385,0-29.669,13.284-29.669,29.67v3.551h3.551&#10;&#9;&#9;&#9;&#9;c16.386,0,29.67-13.283,29.67-29.669V812.539z"
            />
          </g>
          <g>
            <path
              :style="{'fill' : color.color5}"
              d="M578.293,779.345h-20.122c0,16.012-13.028,29.037-29.037,29.037v20.122&#10;&#9;&#9;&#9;&#9;C556.241,828.504,578.293,806.452,578.293,779.345z"
            />
          </g>
          <rect
            x="529.134"
            y="845.336"
            transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 1440.9111 316.2017)"
            :style="{'fill' : color.color1}"
            width="66.442"
            height="66.442"
          />
          <rect
            x="64.066"
            y="845.391"
            transform="matrix(6.123234e-17 -1 1 6.123234e-17 -781.3243 975.8989)"
            :style="{'fill' : color.color2}"
            width="66.442"
            height="66.442"
          />
          <rect
            x="-2.375"
            y="845.391"
            transform="matrix(6.123234e-17 -1 1 6.123234e-17 -847.7659 909.4573)"
            :style="{'fill' : color.color4}"
            width="66.442"
            height="66.442"
          />
          <rect
            x="329.809"
            y="845.336"
            transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 1241.5864 515.5264)"
            :style="{'fill' : color.color5}"
            width="66.442"
            height="66.442"
          />
          <rect
            x="130.508"
            y="845.391"
            transform="matrix(6.123234e-17 -1 1 6.123234e-17 -714.8828 1042.3405)"
            :style="{'fill' : color.color4}"
            width="66.442"
            height="66.441"
          />
          <rect
            x="462.692"
            y="845.318"
            transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 991.8262 1757.0786)"
            :style="{'fill' : color.color2}"
            width="66.442"
            height="66.442"
          />
          <rect
            x="396.251"
            y="845.318"
            transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 858.9431 1757.0786)"
            :style="{'fill' : color.color4}"
            width="66.441"
            height="66.442"
          />
          <rect
            x="196.95"
            y="845.391"
            transform="matrix(6.123234e-17 -1 1 6.123234e-17 -648.4412 1108.782)"
            :style="{'fill' : color.color5}"
            width="66.442"
            height="66.442"
          />
          <rect
            x="263.368"
            y="845.318"
            transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 593.1768 1757.0786)"
            :style="{'fill' : color.color3}"
            width="66.442"
            height="66.442"
          />
          <g>
            <g>
              <g>
                <circle
                  :style="{'fill' : color.color2}"
                  cx="230.17"
                  cy="878.612"
                  r="33.221"
                />
              </g>
              <ellipse
                transform="matrix(0.7071 -0.7071 0.7071 0.7071 -553.8569 420.0944)"
                :style="{'fill' : color.color5}"
                cx="230.17"
                cy="878.612"
                rx="17.186"
                ry="17.186"
              />
              <g>
                <path
                  :style="{'fill' : color.color1}"
                  d="M236.667,878.612c0,3.578-2.911,6.489-6.489,6.489c-3.578,0-6.489-2.911-6.489-6.489&#10;&#9;&#9;&#9;&#9;&#9;&#9;c0-3.578,2.911-6.489,6.489-6.489C233.757,872.123,236.667,875.034,236.667,878.612z"
                />
              </g>
            </g>
          </g>
          <g>
            <g>
              <g>
                <polygon
                  :style="{'fill' : color.color4}"
                  points="554.6,911.76 529.134,911.76 529.134,901.801 544.641,901.801 544.641,881.314 &#10;&#9;&#9;&#9;&#9;&#9;&#9;565.129,881.314 565.129,860.826 585.616,860.826 585.616,845.319 595.575,845.319 595.575,870.786 575.088,870.786 &#10;&#9;&#9;&#9;&#9;&#9;&#9;575.088,891.273 554.6,891.273 &#9;&#9;&#9;&#9;&#9;"
                />
              </g>
            </g>
            <g>
              <g>
                <polygon
                  :style="{'fill' : color.color4}"
                  points="529.134,865.777 529.134,875.735 549.662,875.735 549.662,855.25 570.146,855.25 &#10;&#9;&#9;&#9;&#9;&#9;&#9;570.146,845.318 539.701,845.318 539.701,865.777 &#9;&#9;&#9;&#9;&#9;"
                />
              </g>
            </g>
            <g>
              <g>
                <polygon
                  :style="{'fill' : color.color4}"
                  points="575.081,911.759 565.124,911.759 565.124,901.769 585.611,901.769 585.611,881.281 &#10;&#9;&#9;&#9;&#9;&#9;&#9;595.576,881.281 595.576,891.242 595.569,891.242 595.569,911.729 575.081,911.729 &#9;&#9;&#9;&#9;&#9;"
                />
              </g>
            </g>
          </g>
          <g>
            <rect
              x="405.988"
              y="855.047"
              transform="matrix(-0.7071 0.7071 -0.7071 -0.7071 1354.3793 1196.0676)"
              :style="{'fill' : color.color2}"
              width="46.975"
              height="46.975"
            />
            <rect
              x="415.366"
              y="864.425"
              transform="matrix(-0.7071 -0.7071 0.7071 -0.7071 111.9413 1803.4373)"
              :style="{'fill' : color.color4}"
              width="28.22"
              height="28.22"
            />
            <rect
              x="423.774"
              y="872.832"
              transform="matrix(-0.7071 -0.7071 0.7071 -0.7071 111.9436 1803.4381)"
              :style="{'fill' : color.color2}"
              width="11.405"
              height="11.405"
            />
          </g>
          <polygon
            :style="{'fill' : color.color4}"
            points="329.809,911.777 396.26,878.564 329.809,845.351 &#9;&#9;"
          />
          <g>
            <path
              :style="{'fill' : color.color1}"
              d="M477.366,878.59c0-9.885,8.042-17.927,17.927-17.927c9.885,0,17.927,8.042,17.927,17.927&#10;&#9;&#9;&#9;&#9;c0,9.885-8.042,17.927-17.927,17.927C485.408,896.518,477.366,888.475,477.366,878.59z"
            />
          </g>
          <polygon
            :style="{'fill' : color.color5}"
            points="130.508,845.408 130.508,874.477 64.066,911.851 64.066,882.782 &#9;&#9;"
          />
          <g>
            <path
              :style="{'fill' : color.color2}"
              d="M163.724,878.634h-3.552c-16.385,0-29.669,13.283-29.669,29.67v3.551h3.551&#10;&#9;&#9;&#9;&#9;c16.387,0,29.67-13.284,29.67-29.669V878.634z"
            />
            <path
              :style="{'fill' : color.color2}"
              d="M163.724,875.082c0-16.385-13.283-29.669-29.67-29.669h-3.551v3.551&#10;&#9;&#9;&#9;&#9;c0,16.386,13.283,29.67,29.669,29.67h3.552V875.082z"
            />
            <path
              :style="{'fill' : color.color2}"
              d="M163.724,882.185c0,16.385,13.283,29.669,29.67,29.669h3.551v-3.551&#10;&#9;&#9;&#9;&#9;c0-16.387-13.283-29.67-29.669-29.67h-3.552V882.185z"
            />
            <path
              :style="{'fill' : color.color2}"
              d="M163.724,878.634h3.552c16.385,0,29.669-13.284,29.669-29.67v-3.551h-3.551&#10;&#9;&#9;&#9;&#9;c-16.387,0-29.67,13.284-29.67,29.669V878.634z"
            />
          </g>
          <g>
            <path
              :style="{'fill' : color.color5}"
              d="M14.908,911.828H35.03c0-16.012,13.028-29.037,29.037-29.037v-20.122&#10;&#9;&#9;&#9;&#9;C36.96,862.669,14.908,884.721,14.908,911.828z"
            />
          </g>
          <rect
            x="-71.882"
            y="781.321"
            transform="matrix(6.123234e-17 -1 1 6.123234e-17 -851.2886 778.9429)"
            :style="{'fill' : color.color2}"
            width="71.417"
            height="67.59"
          />
          <g>
            <path
              :style="{'fill' : color.color4}"
              d="M-70.006,798.089v21.629c16.289,0,29.539,14.003,29.539,31.211h20.47&#10;&#9;&#9;&#9;&#9;C-19.998,821.792-42.431,798.089-70.006,798.089z"
            />
          </g>
          <rect
            x="595.517"
            y="779.338"
            transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 1441.2966 183.8202)"
            :style="{'fill' : color.color2}"
            width="66.442"
            height="66.442"
          />
          <polygon
            :style="{'fill' : color.color5}"
            points="595.517,845.762 595.517,816.693 661.959,779.319 661.959,808.388 &#9;&#9;"
          />
          <rect
            x="595.517"
            y="845.316"
            transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 1257.4764 1757.073)"
            :style="{'fill' : color.color2}"
            width="66.442"
            height="66.442"
          />
          <g>
            <path
              :style="{'fill' : color.color1}"
              d="M610.191,878.587c0-9.885,8.042-17.927,17.927-17.927c9.885,0,17.927,8.042,17.927,17.927&#10;&#9;&#9;&#9;&#9;c0,9.885-8.042,17.927-17.927,17.927C618.233,896.515,610.191,888.472,610.191,878.587z"
            />
          </g>
          <g>
            <g>
              <path
                :style="{'fill' : color.color1}"
                d="M604.093,688.174c1.318,0,2.385-1.068,2.385-2.385c0-1.317-1.068-2.385-2.385-2.385&#10;&#9;&#9;&#9;&#9;&#9;c-1.317,0-2.385,1.068-2.385,2.385C601.707,687.106,602.775,688.174,604.093,688.174z"
              />
            </g>
            <g>
              <path
                :style="{'fill' : color.color1}"
                d="M588.381,688.174c1.317,0,2.385-1.068,2.385-2.385c0-1.317-1.068-2.385-2.385-2.385&#10;&#9;&#9;&#9;&#9;&#9;c-1.318,0-2.385,1.068-2.385,2.385C585.995,687.106,587.063,688.174,588.381,688.174z"
              />
            </g>
            <g>
              <path
                :style="{'fill' : color.color1}"
                d="M572.668,688.174c1.317,0,2.385-1.068,2.385-2.385c0-1.317-1.068-2.385-2.385-2.385&#10;&#9;&#9;&#9;&#9;&#9;s-2.385,1.068-2.385,2.385C570.283,687.106,571.351,688.174,572.668,688.174z"
              />
            </g>
            <g>
              <path
                :style="{'fill' : color.color1}"
                d="M556.956,688.174c1.317,0,2.385-1.068,2.385-2.385c0-1.317-1.068-2.385-2.385-2.385&#10;&#9;&#9;&#9;&#9;&#9;c-1.317,0-2.385,1.068-2.385,2.385C554.571,687.106,555.639,688.174,556.956,688.174z"
              />
            </g>
            <g>
              <path
                :style="{'fill' : color.color1}"
                d="M541.244,688.174c1.317,0,2.385-1.068,2.385-2.385c0-1.317-1.068-2.385-2.385-2.385&#10;&#9;&#9;&#9;&#9;&#9;c-1.317,0-2.385,1.068-2.385,2.385C538.859,687.106,539.927,688.174,541.244,688.174z"
              />
            </g>
            <g>
              <path
                :style="{'fill' : color.color1}"
                d="M604.093,665.731c1.318,0,2.385-1.068,2.385-2.385c0-1.317-1.068-2.385-2.385-2.385&#10;&#9;&#9;&#9;&#9;&#9;c-1.317,0-2.385,1.068-2.385,2.385C601.707,664.663,602.775,665.731,604.093,665.731z"
              />
            </g>
            <g>
              <path
                :style="{'fill' : color.color1}"
                d="M588.381,665.731c1.317,0,2.385-1.068,2.385-2.385c0-1.317-1.068-2.385-2.385-2.385&#10;&#9;&#9;&#9;&#9;&#9;c-1.318,0-2.385,1.068-2.385,2.385C585.995,664.663,587.063,665.731,588.381,665.731z"
              />
            </g>
            <g>
              <path
                :style="{'fill' : color.color1}"
                d="M572.668,665.731c1.317,0,2.385-1.068,2.385-2.385c0-1.317-1.068-2.385-2.385-2.385&#10;&#9;&#9;&#9;&#9;&#9;s-2.385,1.068-2.385,2.385C570.283,664.663,571.351,665.731,572.668,665.731z"
              />
            </g>
            <g>
              <path
                :style="{'fill' : color.color1}"
                d="M556.956,665.731c1.317,0,2.385-1.068,2.385-2.385c0-1.317-1.068-2.385-2.385-2.385&#10;&#9;&#9;&#9;&#9;&#9;c-1.317,0-2.385,1.068-2.385,2.385C554.571,664.663,555.639,665.731,556.956,665.731z"
              />
            </g>
            <g>
              <path
                :style="{'fill' : color.color1}"
                d="M541.244,665.731c1.317,0,2.385-1.068,2.385-2.385c0-1.317-1.068-2.385-2.385-2.385&#10;&#9;&#9;&#9;&#9;&#9;c-1.317,0-2.385,1.068-2.385,2.385C538.859,664.663,539.927,665.731,541.244,665.731z"
              />
            </g>
            <g>
              <path
                :style="{'fill' : color.color1}"
                d="M604.093,643.288c1.318,0,2.385-1.068,2.385-2.385c0-1.318-1.068-2.385-2.385-2.385&#10;&#9;&#9;&#9;&#9;&#9;c-1.317,0-2.385,1.068-2.385,2.385C601.707,642.221,602.775,643.288,604.093,643.288z"
              />
            </g>
            <g>
              <path
                :style="{'fill' : color.color1}"
                d="M588.381,643.288c1.317,0,2.385-1.068,2.385-2.385c0-1.318-1.068-2.385-2.385-2.385&#10;&#9;&#9;&#9;&#9;&#9;c-1.318,0-2.385,1.068-2.385,2.385C585.995,642.221,587.063,643.288,588.381,643.288z"
              />
            </g>
            <g>
              <path
                :style="{'fill' : color.color1}"
                d="M572.668,643.288c1.317,0,2.385-1.068,2.385-2.385c0-1.318-1.068-2.385-2.385-2.385&#10;&#9;&#9;&#9;&#9;&#9;s-2.385,1.068-2.385,2.385C570.283,642.221,571.351,643.288,572.668,643.288z"
              />
            </g>
            <g>
              <path
                :style="{'fill' : color.color1}"
                d="M556.956,643.288c1.317,0,2.385-1.068,2.385-2.385c0-1.318-1.068-2.385-2.385-2.385&#10;&#9;&#9;&#9;&#9;&#9;c-1.317,0-2.385,1.068-2.385,2.385C554.571,642.221,555.639,643.288,556.956,643.288z"
              />
            </g>
            <g>
              <path
                :style="{'fill' : color.color1}"
                d="M541.244,643.288c1.317,0,2.385-1.068,2.385-2.385c0-1.318-1.068-2.385-2.385-2.385&#10;&#9;&#9;&#9;&#9;&#9;c-1.317,0-2.385,1.068-2.385,2.385C538.859,642.221,539.927,643.288,541.244,643.288z"
              />
            </g>
          </g>
          <path
            :style="{'fill' : color.color1}"
            d="M529.081,778.852v0.531h66.227v-66.723h-0.035C558.716,712.661,529.081,742.296,529.081,778.852z"
          />
          <rect
            x="595.314"
            y="712.665"
            transform="matrix(6.123234e-17 -1 1 6.123234e-17 -117.3505 1374.4205)"
            :style="{'fill' : color.color4}"
            width="66.442"
            height="66.442"
          />
          <g>
            <path
              :style="{'fill' : color.color4}"
              d="M595.283,802.567V779.36h23.711C618.908,792.191,608.327,802.567,595.283,802.567z"
            />
            <path
              style="fill:#003041;"
              d="M595.283,755.228c13.098,0,23.715,10.733,23.715,23.972c0,0.054-0.004,0.107-0.004,0.16h-23.711&#10;&#9;&#9;&#9;&#9;V755.228z"
            />
          </g>
          <g>
            <path
              :style="{'fill' : color.color2}"
              d="M661.756,761.823v-20.122c-16.009,0-29.037-13.024-29.037-29.037h-20.122&#10;&#9;&#9;&#9;&#9;C612.597,739.771,634.649,761.823,661.756,761.823z"
            />
          </g>
        </g>
      </g>
    </svg>
    <svg
      v-if="template == 'abriron8'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 595.276 841"
      style="enable-background:new 0 0 595.276 841;"
    >
      <g transform="matrix(1, 0, 0, 1, 0, 1.4210854715202004e-14)">
        <g
          style=""
          transform="matrix(-0.903016, 0, 0, 0.903016, 598.259591, -4.029618)"
        >
          <polygon
            :style="{'fill' : color.color3}"
            points="136.415 -14.17 6.63 55.109 -14.17 5.725 -14.17 -14.17"
          />
          <polygon
            :style="{'fill' : color.color4}"
            points="61.122 -14.17 -14.17 100.597 -14.17 -14.17"
          />
        </g>
        <g
          style=""
          transform="matrix(-0.605204, 0, 0, 0.605204, 352.613256, 340.967595)"
        >
          <polygon
            :style="{'fill' : color.color4}"
            points="376.55,856.06 577.28,748.91 609.45,825.29 609.45,856.06"
          />
          <polygon
            :style="{'fill' : color.color3}"
            points="493,856.06 609.45,678.557 609.45,856.06"
          />
        </g>
      </g>
      <rect
        x="218.73"
        y="108.309"
        style="fill:none;"
        width="157.82"
        height="13.565"
        transform="matrix(1, 0, 0, 1, 0, 1.4210854715202004e-14)"
      />
      <rect
        x="258.618"
        y="125.156"
        style="fill:none;"
        width="78.043"
        height="5.142"
        transform="matrix(1, 0, 0, 1, 0, 1.4210854715202004e-14)"
      />
      <rect
        x="69.341"
        y="254.211"
        style="fill:none;"
        width="346.483"
        height="9.165"
        transform="matrix(1, 0, 0, 1, 0, 1.4210854715202004e-14)"
      />
      <rect
        x="69.341"
        y="210.626"
        style="fill:none;"
        width="122.5"
        height="10.76"
        transform="matrix(1, 0, 0, 1, 0, 1.4210854715202004e-14)"
      />
      <rect
        x="216.28"
        y="765.505"
        style="fill:none;"
        width="162.72"
        height="14.293"
        transform="matrix(1, 0, 0, 1, 0, 1.4210854715202004e-14)"
      />
      <rect
        x="239.447"
        y="781.999"
        style="fill:none;"
        width="116.387"
        height="7.147"
        transform="matrix(1, 0, 0, 1, 0, 1.4210854715202004e-14)"
      />
      <rect
        x="69.341"
        y="276.169"
        style="fill:none;"
        width="456.598"
        height="164.902"
        transform="matrix(1, 0, 0, 1, 0, 1.4210854715202004e-14)"
      />
      <rect
        x="69.341"
        y="480.836"
        style="fill:none;"
        width="346.483"
        height="9.165"
        transform="matrix(1, 0, 0, 1, 0, 1.4210854715202004e-14)"
      />
      <rect
        x="69.341"
        y="502.795"
        style="fill:none;"
        width="456.598"
        height="140.542"
        transform="matrix(1, 0, 0, 1, 0, 1.4210854715202004e-14)"
      />
      <rect
        x="229.28"
        y="709.76"
        style="fill:none;"
        width="136.72"
        height="7.417"
        transform="matrix(1, 0, 0, 1, 0, 1.4210854715202004e-14)"
      />
    </svg>
    <svg
      v-if="template == 'abriron2-land'"
      version="1.1"
      x="0px"
      y="0px"
      viewBox="0 0 842 595.3"
      style="enable-background:new 0 0 595.276 841.89;"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs />
      <g
        id="OBJECTS"
        transform="matrix(1.365461, 0, 0, 0.694061, 14.857284, 4.548683)"
        style=""
      >
        <g>
          <g>
            <defs>
              <rect
                id="SVGID_1_"
                x="-8.504"
                y="-8.504"
                width="612.283"
                height="858.898"
              />
            </defs>
            <clipPath id="SVGID_00000120549937014479107850000005555152656919434902_">
              <rect
                x="-8.504"
                y="-8.504"
                width="612.283"
                height="858.898"
                style="overflow: visible;"
              />
            </clipPath>
            <g style="clip-path:url(#SVGID_00000120549937014479107850000005555152656919434902_);">
              <g transform="matrix(1, 0, 0, 1, -49.40347, 33.802327)">
                <radialGradient
                  id="SVGID_00000125586229906657515770000013445674848138280376_"
                  cx="110.7759"
                  cy="584.2944"
                  r="477.6465"
                  gradientTransform="matrix(-1 0 0 0.8748 583.1153 106.6981)"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop
                    offset="0.2055"
                    :style="{'stop-color' : color.color1}"
                  />
                  <stop
                    offset="0.2477"
                    :style="{'stop-color' : color.color1}"
                  />
                  <stop
                    offset="0.4863"
                    :style="{'stop-color' : color.color1}"
                  />
                  <stop
                    offset="0.6997"
                    :style="{'stop-color' : color.color1}"
                  />
                  <stop
                    offset="0.8782"
                    :style="{'stop-color' : color.color1}"
                  />
                  <stop
                    offset="1"
                    :style="{'stop-color' : color.color1}"
                  />
                </radialGradient>
                <path
                  style="fill:url(#SVGID_00000125586229906657515770000013445674848138280376_);"
                  d="M603.846,821.456v57.89H-8.437v-46.681c0,0,127.267-57.399,324.977-57.399S603.846,821.456,603.846,821.456z"
                />
                <g>
                  <radialGradient
                    id="SVGID_00000049911933155800977390000012159653364123951781_"
                    cx="-655.6994"
                    cy="1203.6003"
                    r="122.4368"
                    gradientTransform="matrix(-1.9765 0.0823 0.0593 0.9985 -867.4375 -440.1475)"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop
                      offset="0"
                      :style="{'stop-color' : color.color3}"
                    />
                    <stop
                      offset="1"
                      :style="{'stop-color' : color.color4}"
                    />
                  </radialGradient>
                  <path
                    style="fill:url(#SVGID_00000049911933155800977390000012159653364123951781_);"
                    d="M-64.203,858.531c210.737-119.763,540.087-125.647,730.096-38.447c-9.792,6.6-19.584,13.2-29.376,19.801C478.83,753.57,160.821,743.224-64.203,858.531z"
                  />
                  <radialGradient
                    id="SVGID_00000157298188153445577530000017681371714901268385_"
                    cx="-656.5322"
                    cy="1221.6813"
                    r="358.072"
                    gradientTransform="matrix(-1.9725 0.1502 0.0593 0.9985 -865.2245 -398.4704)"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop
                      offset="0"
                      :style="{'stop-color' : color.color3}"
                    />
                    <stop
                      offset="1"
                      :style="{'stop-color' : color.color4}"
                    />
                  </radialGradient>
                  <path
                    style="fill:url(#SVGID_00000157298188153445577530000017681371714901268385_);"
                    d="M-27.709,841.452c214.559-102.329,519.502-92.763,679.653-3.158c-10.146,5.719-21.793,23.007-30.439,17.159C492.182,767.976,216.806,742.184-27.709,841.452z"
                  />
                </g>
              </g>
              <g
                style="transform-origin: 300.845px 53.884px;"
                transform="matrix(0.994269, -0.01062, 0.007908, 0.726029, 2.136596, -36.768929)"
              >
                <radialGradient
                  id="SVGID_00000148634419000472530040000013349810195195226524_"
                  cx="-43.9306"
                  cy="-60.585"
                  r="589.9821"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="matrix(1.025624, 0, 0, 0.998817, -11.548942, -0.010065)"
                >
                  <stop
                    offset="0"
                    :style="{'stop-color' : color.color3}"
                  />
                  <stop
                    offset="1"
                    :style="{'stop-color' : color.color4}"
                  />
                </radialGradient>
                <path
                  style="fill: url('#SVGID_00000148634419000472530040000013349810195195226524_'); transform-box: fill-box; transform-origin: 50% 50%;"
                  d="M 607.701 88.327 L 607.701 -8.504 L -20.271 -8.504 L -20.271 77.031 C -20.271 77.031 87.701 25.612 278.685 25.612 C 469.669 25.612 607.701 88.327 607.701 88.327 Z"
                />
                <g>
                  <radialGradient
                    id="SVGID_00000142174250476451159050000001351435881678517665_"
                    cx="-677.9474"
                    cy="462.0608"
                    r="122.4368"
                    gradientTransform="matrix(1.9765 0.0823 -0.0593 0.9985 1469.1263 -440.1475)"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop
                      offset="0"
                      :style="{'stop-color' : color.color3}"
                    />
                    <stop
                      offset="1"
                      :style="{'stop-color' : color.color4}"
                    />
                  </radialGradient>
                  <path
                    style="fill:url(#SVGID_00000142174250476451159050000001351435881678517665_);"
                    d="M665.892,116.272C455.155-3.491,125.805-9.374-64.203,77.825c9.792,6.6,19.584,13.2,29.376,19.801C122.859,11.312,440.868,0.966,665.892,116.272z"
                  />
                  <radialGradient
                    id="SVGID_00000111889079126656740020000001576158042398750638_"
                    cx="-678.7798"
                    cy="481.6546"
                    r="358.072"
                    gradientTransform="matrix(1.9725 0.1502 -0.0593 0.9985 1466.9135 -398.4704)"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop
                      offset="0"
                      :style="{'stop-color' : color.color3}"
                    />
                    <stop
                      offset="1"
                      :style="{'stop-color' : color.color4}"
                    />
                  </radialGradient>
                  <path
                    style="fill:url(#SVGID_00000111889079126656740020000001576158042398750638_);"
                    d="M629.398,99.194C414.839-3.135,109.896,6.431-50.254,96.036c10.146,5.719,21.793,23.007,30.439,17.159C109.507,25.718,384.882-0.074,629.398,99.194z"
                  />
                </g>
              </g>
            </g>
          </g>
          <g />
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
  export default {
    name: 'PrintBackground',
    components: {
      // aicomplete,
    },
    props: ['color', 'template'],
    data: () => ({
      colors: null,
    }),
    watch: {
      color (val) {
      },
      template (val) {},
    },
    activated () {
    },
    beforeMount () {
    },
    mounted () {
    },
    methods: {
    },
  }
</script>

<style scoped>

</style>
